package org.hs_soft.runmynesto.domain.model.home.options.export.option_credit_card

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("getAppConfig")
    val getAppConfig: GetAppConfig?, // AppConfig
    @SerialName("__typename")
    val typename: String?
)